import { ColumnDef, Row } from '@tanstack/react-table';
import AdvanceTable from 'components/base/AdvanceTable';
import useAdvanceTable from 'hooks/useAdvanceTable';
import AdvanceTableProvider from 'providers/AdvanceTableProvider';
import { Link } from 'react-router-dom';
import AdvanceTableFooter from 'components/base/AdvanceTableFooter';
import axios from 'axios';
import React, { useState, useEffect } from 'react';
import TipoDeMtoDetailsModal from 'components/modules/project-management/todo-list/TipoDeMtoDetailsModal'



const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:2000';

interface EditableCellProps {
  value: string | number | null;
  rowId: number | string;
  columnId: string;
  apiUrl: string;
}

const EditableCell = ({ value, rowId, columnId, apiUrl }: EditableCellProps) => {
  const [isEditing, setIsEditing] = useState(false);
  const [currentValue, setCurrentValue] = useState(value);

  const handleBlur = async () => {
    setIsEditing(false);
    try {
      // Adjust this endpoint/payload to match your backend expectations
      await axios.post(`${apiUrl}/tMtos/update-field`, {
        id: rowId,
        field: columnId,
        value: currentValue,
      });
    } catch (err) {
      console.error('Update failed:', err);
      alert('Failed to update field');
      setCurrentValue(value); // Revert on error
    }
  };

  return isEditing ? (
    <input
      autoFocus
      className="form-control form-control-sm"
      value={currentValue || ''}
      onChange={(e) => setCurrentValue(e.target.value)}
      onBlur={handleBlur}
      onKeyDown={(e) => e.key === 'Enter' && handleBlur()}
    />
  ) : (
    <div 
      onClick={() => setIsEditing(true)} 
      style={{ cursor: 'pointer', minHeight: '20px' }}
      title="Click to edit"
    >
      {currentValue || <span className="text-muted italic">Empty</span>}
    </div>
  );
};

// Define the interface for each row in procRows
interface TiposRow {
  id: string;
  nombre: string;
  descripcion: string;
  clase: string;
  titulo: string;
  texto: string;
  informe: string;
  proximo_paso: string;
  ppEnCuantosDias: number;
  estado: string;
}

// Define the interface for props
interface TiposDeMovimientosDashboardTableProps {
  tiposRows: TiposRow[];
}




const TiposDeMovimientosDashboardTable: React.FC<TiposDeMovimientosDashboardTableProps> = ({ tiposRows }) => {
const [selectedItem, setSelectedItem] = useState<TiposRow | null>(null);

const columns: ColumnDef<TiposRow>[] = [

  {
    header: 'id',
    accessorKey: 'id',
    cell: ({ row, getValue }) => (
      <div 
      
        onClick={() => setSelectedItem(row.original)} 
        style={{ cursor: 'pointer', color: '#3874ff', fontWeight: 'bold' }}
      >
        {getValue() as string}
      </div>
    ),
    meta: {
      cellProps: { 
      className: 'ps-3 fs-9 text-body', 
      style: { 
        maxWidth: '200px',        // You must set a max-width for ellipsis to work
        whiteSpace: 'nowrap',     // Prevents text from jumping to a new line
        overflow: 'hidden',       // Hides the text that goes past the edge
        textOverflow: 'ellipsis'  // Adds the "..."
      } 
      },
        headerProps: { style: { width: '15%' }, className: 'ps-3' }
    }
  },
    {
    header: 'nombre',
    accessorKey: 'nombre',
    meta: {
      cellProps: { 
      className: 'ps-3 fs-9 text-body', 
      style: { 
        maxWidth: '200px',        // You must set a max-width for ellipsis to work
        whiteSpace: 'nowrap',     // Prevents text from jumping to a new line
        overflow: 'hidden',       // Hides the text that goes past the edge
        textOverflow: 'ellipsis'  // Adds the "..."
      } 
      },
        headerProps: { style: { width: '15%' }, className: 'ps-3' }
    }
  },
    {
    header: 'descripcion',
    accessorKey: 'descripcion',
    meta: {
      cellProps: { 
      className: 'ps-3 fs-9 text-body', 
      style: { 
        maxWidth: '200px',        // You must set a max-width for ellipsis to work
        whiteSpace: 'nowrap',     // Prevents text from jumping to a new line
        overflow: 'hidden',       // Hides the text that goes past the edge
        textOverflow: 'ellipsis'  // Adds the "..."
      } 
      },
        headerProps: { style: { width: '15%' }, className: 'ps-3' }
    }
    },
    {
    header: 'clase',
    accessorKey: 'clase',
    meta: {
      cellProps: { className: 'ps-3 fs-9 text-body white-space-nowrap' },
      headerProps: { style: { width: '10%' }, className: 'ps-3' }
    }
  },
    {
    header: 'titulo',
    accessorKey: 'titulo',
    meta: {
      cellProps: { 
      className: 'ps-3 fs-9 text-body', 
      style: { 
        maxWidth: '200px',        // You must set a max-width for ellipsis to work
        whiteSpace: 'nowrap',     // Prevents text from jumping to a new line
        overflow: 'hidden',       // Hides the text that goes past the edge
        textOverflow: 'ellipsis'  // Adds the "..."
      } 
      },
        headerProps: { style: { width: '15%' }, className: 'ps-3' }
    }
  },
      {
    header: 'texto',
    accessorKey: 'texto',
    meta: {
      cellProps: { className: 'ps-3 fs-9 text-body white-space-nowrap' },
      headerProps: { style: { width: '10%' }, className: 'ps-3' }
    }
  },
  {
    header: 'informe',
    accessorKey: 'informe',
    meta: {
      cellProps: { 
      className: 'ps-3 fs-9 text-body', 
      style: { 
        maxWidth: '200px',        // You must set a max-width for ellipsis to work
        whiteSpace: 'nowrap',     // Prevents text from jumping to a new line
        overflow: 'hidden',       // Hides the text that goes past the edge
        textOverflow: 'ellipsis'  // Adds the "..."
      } 
      },
        headerProps: { style: { width: '15%' }, className: 'ps-3' }
    }
  },
    {
    header: 'proximo_paso',
    accessorKey: 'proximo paso',
    meta: {
      cellProps: { className: 'ps-3 fs-9 text-body white-space-nowrap' },
      headerProps: { style: { width: '10%' }, className: 'ps-3' }
    }
  },
      {
    header: 'ppEnCuantosDias',
    accessorKey: 'pp En Cuantos Dias',
    meta: {
      cellProps: { 
      className: 'ps-3 fs-9 text-body', 
      style: { 
        maxWidth: '200px',        // You must set a max-width for ellipsis to work
        whiteSpace: 'nowrap',     // Prevents text from jumping to a new line
        overflow: 'hidden',       // Hides the text that goes past the edge
        textOverflow: 'ellipsis'  // Adds the "..."
      } 
      },
        headerProps: { style: { width: '15%' }, className: 'ps-3' }
    }
  }
];

  const table = useAdvanceTable({
    data: tiposRows,
    columns,
    pageSize: 150,
    pagination: true,
    sortable: true
  });

  const handleRowClick = (row: Row<TiposRow>) => {
    setSelectedItem(row.original);
  };
  return (

    <div style={{ overflowX: 'auto', width: '100%' }}>
      <AdvanceTableProvider {...table}>
        <AdvanceTable
          tableProps={{
            className: 'phoenix-table border-top border-translucent fs-9 table-responsive',
            style: { width: '100%', tableLayout: 'fixed' }
          }}
        />
        <AdvanceTableFooter pagination />
      </AdvanceTableProvider>

      <TipoDeMtoDetailsModal 
        TiposRow  ={selectedItem} 
        handleClose={() => setSelectedItem(null)} 
      />

    </div>
  );
};

export default TiposDeMovimientosDashboardTable;